export default __webpack_public_path__ + "static/media/72.9edf1357.png";